import type { UseQueryResult, QueryFunctionContext } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { homePageQueryKeys } from "../services/queries/queryKeyFactory";
import type { SavedSearchesDto } from "../types/savedSearchesDto";

const useSavedSearchesQuery = (): UseQueryResult<SavedSearchesDto> => {
    return useQuery({
        queryKey: homePageQueryKeys.savedSearches(),
        retry: false,
        throwOnError: true,
        queryFn({ signal }: QueryFunctionContext): Promise<SavedSearchesDto> {
            return salesApiService.home.fetchSavedSearches({
                cancellation: signal,
            });
        },
    });
};

export default useSavedSearchesQuery;
